import { FunctionComponent } from "react";
import { Text } from "@ui-kit/Text/Text";
import "./RadioButtonGroup.css";

interface ToggleTextOption {
  label: string;
}

interface RadioButtonGroupProps {
  options: [ToggleTextOption, ToggleTextOption];
  selectedIndex: 0 | 1;
  onToggle: (index: 0 | 1) => void;
  backgroundColor?: string;
}

/**
 * Large toggle button with two options. Similar to Switch but ever present text and larger.
 */
const RadioButtonGroup: FunctionComponent<RadioButtonGroupProps> = ({
  options,
  selectedIndex,
  onToggle,
}) => {
  return (
    <div className="toggle-container">
      {options.map((option, index) => (
        <button
          key={index}
          className={`toggle-button ${selectedIndex === index ? "selected" : ""}`}
          onClick={() => onToggle(index as 0 | 1)}>
          <Text
            variant="fontBodyMedium"
            className={`toggle-text ${selectedIndex === index ? "selected" : ""}`}>
            {option.label}
          </Text>
        </button>
      ))}
    </div>
  );
};

export { RadioButtonGroup, type ToggleTextOption };
